import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { CONTACT } from "@/i18n/translations";

const DEFAULT = {
  contact: {
    phoneDisplay: CONTACT.phoneDisplay,
    phoneTel: CONTACT.phoneTel,
    whatsapp: CONTACT.whatsapp,
    email: CONTACT.email,
  },
  hero: {},
  about: {},
  services: {},
};

const SiteContext = createContext({ ...DEFAULT, reload: () => {} });

export const useSite = () => useContext(SiteContext);

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent({
        ...DEFAULT,
        ...data,
        contact: { ...DEFAULT.contact, ...(data.contact || {}) },
        hero: data.hero || {},
        about: data.about || {},
        services: data.services || {},
      });
    } catch {
      /* keep defaults */
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return <SiteContext.Provider value={{ ...content, reload }}>{children}</SiteContext.Provider>;
};
